import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconLeaderboard"><Path d="M10.5 6C9.39543 6 8.5 6.89543 8.5 8V18H15.5V8C15.5 6.89543 14.6046 6 13.5 6H10.5Z" fill="currentColor"/><Path d="M2.5 8.5C1.39543 8.5 0.5 9.39543 0.5 10.5V16C0.5 17.1046 1.39543 18 2.5 18H7V8.5H2.5Z" fill="currentColor"/><Path d="M17 10V18H21.5C22.6046 18 23.5 17.1046 23.5 16V12C23.5 10.8954 22.6046 10 21.5 10H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLeaderboard;
